export default __webpack_public_path__ + "static/media/31-lead.c61d7ea7.png";